import { CustomTag } from '../types'
import { getApiClient } from './apiClient'

export const createCustomTag = async (tag: CustomTag): Promise<CustomTag> => {
  const response = await getApiClient().post('/', JSON.stringify({ ...tag }))

  return response.data
}

export const fetchCustomTags = async (): Promise<CustomTag[]> => {
  const response = await getApiClient().get('')

  return response.data
}

export const updateCustomTag = async (tags: CustomTag[]): Promise<CustomTag> => {
  const response = await getApiClient().put('/', JSON.stringify(tags))

  return response.data
}

export const deleteCustomTag = async (id: number): Promise<void> => {
  const response = await getApiClient().delete(`/${id}`)

  return response.data
}
